import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/AuthHeader.module.css";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getIniciais, getPrimeiroNome } from "../utils/Utils";
import { ArrowForwardIos } from "@material-ui/icons";
import { avatarMenuOptions, headerMenuOptions } from "../pages/home/MenuConfig";
import { useMediaQuery } from "react-responsive";
import { IconButton } from "@material-ui/core";
import AvatarMenuItem from "./AvatarMenuItem";

export default function AuthHeader() {
    const menuAvatarRef = useRef(null);
    const menuHeaderRef = useRef([]);

    const [HeaderOptions, setHeaderOptions] = useState(headerMenuOptions);
    const [AvatarOptions, setAvatarOptions] = useState(avatarMenuOptions);
    const [openAvatarMenu, setOpenAvatarMenu] = useState(false);
    const [openHeaderMenu, setOpenHeaderMenu] = useState(null);
    const [avatarMenuAnimation, setAvatarMenuAnimation] = useState("out");
    const [headerMenuAnimation, setHeaderMenuAnimation] = useState("out");

    const history = useHistory();
    const location = useLocation();

    const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });

    const { user, parceiro_user } = useSelector((state) => state.auth);

    const toggleAvatarMenu = (to) => {
        if (to) {
            setAvatarMenuAnimation("in");

            setOpenAvatarMenu(true);
        } else {
            setAvatarMenuAnimation("out");

            const timer = setTimeout(() => {
                setOpenAvatarMenu(false);
            }, 300);

            return () => clearTimeout(timer);
        }
    };

    const toggleOutHeaderMenu = () => {
        setHeaderMenuAnimation("out");

        const timer = setTimeout(() => {
            setOpenHeaderMenu(null);
        }, 300);

        return () => clearTimeout(timer);
    };

    const handleClickOnScreen = (event) => {
        if (menuAvatarRef.current && !menuAvatarRef.current.contains(event.target)) {
            toggleAvatarMenu(false);
        }

        if (menuHeaderRef.current && !menuHeaderRef.current.some((e) => e?.contains(event.target))) {
            toggleOutHeaderMenu();
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOnScreen);

        return () => {
            document.removeEventListener("mousedown", handleClickOnScreen);
        };
    }, []);

    useEffect(() => {
        if (parceiro_user) {
            const permissions = parceiro_user.permissions_format;

            let headerOp = HeaderOptions.filter((option) => (option.subMenu ? option.subMenu.some((submenu) => permissions.some((p) => submenu.id.includes(p.controller)) || submenu.id === "global") : permissions.some((p) => option.id.includes(p.controller)) || option.id === "global"));
            let avatarOp = AvatarOptions.filter((option) => (option.subMenu ? option.subMenu.some((submenu) => permissions.some((p) => submenu.id.includes(p.controller)) || submenu.id === "global") : permissions.some((p) => option.id.includes(p.controller)) || option.id === "global"));

            setHeaderOptions(
                headerOp.map((menu) => {
                    if (menu.subMenu) {
                        return {
                            ...menu,
                            subMenu: menu.subMenu.filter((subMenuOption) => permissions.some((p) => subMenuOption.id.includes(p.controller)) || subMenuOption.id === "global"),
                        };
                    }

                    return menu;
                })
            );

            setAvatarOptions(
                avatarOp.map((menu) => {
                    if (menu.subMenu) {
                        return {
                            ...menu,
                            subMenu: menu.subMenu.filter((subMenuOption) => permissions.some((p) => subMenuOption.id.includes(p.controller)) || subMenuOption.id === "global"),
                        };
                    }

                    return menu;
                })
            );
        }
    }, [parceiro_user]);

    return (
        <header className={`${styles.header} ${isMobile ? styles.mobile : ""} containerRow`}>
            <div>
                <img src="/images/logo-dark.png" className={styles.logo} alt="Lumi" onClick={() => history.push("/")} />
            </div>

            {!isMobile ? (
                <div className={`d-flex gap-32 ${styles.headerMenuContainer}`}>
                    {HeaderOptions.map((menuItem, index) => {
                        const hasSubMenu = !menuItem.path && menuItem.subMenu;
                        const isActive = location.pathname.includes(menuItem.path) || (hasSubMenu ? menuItem.subMenu.some((subMenu) => location.pathname.includes(subMenu.path)) : false);

                        return (
                            <>
                                <div
                                    ref={(el) => (menuHeaderRef.current[index] = el)}
                                    key={`menu${menuItem.id}`}
                                    className={`d-flex align-items-center gap-8 ${styles.headerMenuOption} ${isActive ? styles.active : ""}`}
                                    onClick={() => {
                                        if (menuItem.path) {
                                            history.push(menuItem.path);
                                        }

                                        if (hasSubMenu) {
                                            if ((openHeaderMenu || openHeaderMenu?.index === index)) {
                                                toggleOutHeaderMenu();
                                            } else {
                                                setHeaderMenuAnimation("in");
                                                setOpenHeaderMenu({ menuItem, index });
                                            }
                                        }
                                    }}
                                >
                                    {menuItem.icon}
                                    <span className="tt-16 color-gray-09 semibold text-nowrap">{menuItem.label}</span>

                                    {hasSubMenu ? <ArrowForwardIos style={{ color: "#FFF", rotate: openHeaderMenu ? "270deg" : "90deg", fontSize: 13, fontWeight: 400 }} /> : null}
                                </div>

                                {hasSubMenu ? (
                                    <div
                                        key={`submenu${menuItem.id}`}
                                        className={`${styles.subMenuHeaderContainer} ${headerMenuAnimation === "out" ? styles.fadeOut : styles.fadeIn}`}
                                        style={{
                                            display: openHeaderMenu?.index === index ? "flex" : "none",
                                            top: menuHeaderRef.current[index]?.getBoundingClientRect().bottom,
                                            left: menuHeaderRef.current[index]?.getBoundingClientRect().left,
                                            cursor: "pointer",
                                        }}
                                    >
                                        {openHeaderMenu?.menuItem.subMenu.map((subMenu, index) => {
                                            const isActiveSubMenu = location.pathname.includes(subMenu.path);

                                            return (
                                                <div
                                                    key={`submenu-item${index}`}
                                                    className={isActiveSubMenu ? styles.activeSubMenu : ""}
                                                    onClick={() => {
                                                        if (subMenu.path) {
                                                            history.push(subMenu.path);
                                                            toggleOutHeaderMenu();
                                                        }
                                                    }}
                                                >
                                                    <span className="tt-16 semibold color-white">{subMenu.label}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : null}
                            </>
                        );
                    })}
                </div>
            ) : null}

            <div className={styles.avatarMenuContainer} ref={menuAvatarRef}>
                {isMobile ? (
                    <IconButton onClick={() => toggleAvatarMenu(!openAvatarMenu)}>
                        <i className="fas fa-bars" style={{ fontSize: 20 }} />
                    </IconButton>
                ) : (
                    <div onClick={() => toggleAvatarMenu(!openAvatarMenu)} className="d-flex align-items-center gap-8" style={{ cursor: "pointer" }}>
                        <p className="tt-14 color-gray-09 m-0">{getPrimeiroNome(user?.ctm_name)}</p>

                        <div className={styles.avatar} style={user?.logo ? { backgroundImage: `url(${user?.logo?.url})`, backgroundSize: "cover", backgroundPosition: "center", cursor: "pointer" } : null}>
                            {!user?.logo && <p>{getIniciais(user?.ctm_name)}</p>}
                        </div>


                        <ArrowForwardIos style={{ color: "#1C274C", rotate: "90deg", fontSize: 13, fontWeight: 400 }} />
                    </div>
                )}

                <div className={`${styles.menuAvatar} ${avatarMenuAnimation === "out" ? styles.fadeOut : styles.fadeIn} ${isMobile ? styles.mobile : ""}`} style={{ display: openAvatarMenu ? "flex" : "none" }}>

                    {isMobile
                        ? HeaderOptions.map((menuItem, index) => {
                            if (menuItem.subMenu && menuItem.subMenu.length) {
                                return menuItem.subMenu.map((subMenuItem, i) => {
                                    const isActive = location.pathname.includes(subMenuItem.path);
                                    return (
                                        <AvatarMenuItem
                                            isMobile={isMobile}
                                            isActive={isActive}
                                            key={`avatar-menu-item-${index}-${i}`}
                                            menuItem={subMenuItem}
                                            onClick={() => {
                                                setOpenAvatarMenu(false);
                                                history.push(subMenuItem.path);
                                            }}
                                        />
                                    );
                                });
                            } else {
                                const isActive = location.pathname.includes(menuItem.path);
                                return (
                                    <AvatarMenuItem
                                        isMobile={isMobile}
                                        isActive={isActive}
                                        key={`avatar-menu-item-${index}`}
                                        menuItem={menuItem}
                                        onClick={() => {
                                            setOpenAvatarMenu(false);
                                            history.push(menuItem.path);
                                        }}
                                    />
                                );
                            }
                        })
                        : null}

                    {AvatarOptions.map((menuItem, index) => {
                        const isActive = location.pathname.includes(menuItem.path);
                        return (
                            <AvatarMenuItem
                                showIcon
                                key={`avatar-menu-itemt-${index}`}
                                isMobile={isMobile}
                                isActive={isActive}
                                menuItem={menuItem}
                                onClick={() => {
                                    setOpenAvatarMenu(false);
                                    history.push(menuItem.path);
                                }}
                            />
                        );
                    })}
                </div>
            </div>
        </header>
    );
}
